import cubejs from '@cubejs-client/core';
import { QueryRenderer } from '@cubejs-client/react';
import { Spin } from 'antd';
import 'antd/dist/antd.css';
import React from 'react';
import { Row, Col, Statistic} from 'antd';

import { cubejsApiTokenPromise, cubejsOptions } from './cube-config';

const cubejsApi = cubejs(
  cubejsApiTokenPromise,
  cubejsOptions
);

const renderChart = ({ resultSet, error, pivotConfig }) => {
  if (error) {
    return <div>{error.toString()}</div>;
  }

  if (!resultSet) {
    return <Spin />;
  }

  return (
  <Row
    type="flex"
    justify="center"
    align="middle"
    style={{
      height: '100%',
    }}
  >
    <Col>
      {resultSet.seriesNames().map((s) => (
        <Statistic value={resultSet.totalRow()[s.key]} />
      ))}
    </Col>
  </Row>
  
  
);

};

const NumberRules = ({ tiporegla}) => {
  return (
    <QueryRenderer
      query={{
  "measures": [
    "Regla.count"
  ],
  "timeDimensions": [],
  "order": {},
  "filters": [
    {
      "member": "Regla.estado",
      "operator": "equals",
      "values": [
        tiporegla
      ]
    }
  ]
}}
      cubejsApi={cubejsApi}
      resetResultSetOnChange={false}
      render={(props) => renderChart({
        ...props,
        chartType: 'number',
        pivotConfig: {
  "x": [],
  "y": [
    "measures"
  ],
  "fillMissingDates": true,
  "joinDateRange": false
}
      })}
    />
  );
};

export default NumberRules;

      